<ion-content class="pg-main-content" [fullscreen]="true">
  <div class="pg-wallet-layout" [class.has-docked-fab]="hasAppbar">

    <!-- Barra Superior Integrada Estilo pgarcia-theme -->
    <div class="pg-topbar">
      <div class="pg-topbar-left">
        <button class="pg-icon-btn" (click)="closePage()">
          <ion-icon name="chevron-back-outline"></ion-icon>
        </button>
        <div class="pg-topbar-texts">
          <h1 class="pg-topbar-title">{{ pageTitle }}</h1>
          <span class="pg-topbar-sub">{{ pageSubTitle }}</span>
        </div>
      </div>

      <div class="pg-header-actions">
        <div class="pg-topbar-badge" [ngStyle]="{'color': iconColor}">
          <ion-icon [name]="iconName"></ion-icon>
        </div>
      </div>
    </div>

    <!-- Buscador Unificado -->
    <div class="pg-search-wrapper">
      <ion-searchbar 
        [(ngModel)]="searchText" 
        (ionInput)="filterItems()" 
        [placeholder]="'Buscar en ' + pageTitle.toLowerCase() + '...'"
        class="pg-searchbar">
      </ion-searchbar>
    </div>

    <!-- Área con Scroll para Listado -->
    <div class="admin-crud-scroll-area">
      <!-- Listado con Cards Soft UI -->
      <div class="cards-list">
        <div class="pg-crud-card" *ngFor="let item of filteredItems" (click)="openEditModal(item)">
          <div class="card-left">
            <div class="item-icon-wrap" [ngStyle]="{'color': iconColor}">
              <ion-icon [name]="iconName"></ion-icon>
            </div>
            <div class="item-details">
              <h3 class="item-name">{{ getName(item) }}</h3>
              <p class="item-detail">{{ getDetail(item) }}</p>
              <p *ngIf="getSubDetail(item)" class="item-sub-detail">{{ getSubDetail(item) }}</p>

              <div *ngIf="entity === 'GRUPO' && getSolicitorsByGroup(item.dt1).length > 0" class="badges-row">
                <span *ngFor="let s of getSolicitorsByGroup(item.dt1)" class="solicitor-badge">
                  <ion-icon name="person-outline"></ion-icon> {{ s.dt2 }}
                </span>
              </div>
            </div>
          </div>

          <div class="card-right">
            <ion-icon name="chevron-forward-outline" class="card-arrow"></ion-icon>
          </div>
        </div>

        <div *ngIf="filteredItems.length === 0 && !loading" class="empty-state">
          <div class="empty-icon-wrap">
            <ion-icon [name]="iconName"></ion-icon>
          </div>
          <h4>No se encontraron registros</h4>
          <p>No hay elementos registrados o coincidentes con la búsqueda.</p>
        </div>

        <div *ngIf="loading" class="loading-state">
          <ion-spinner name="crescent"></ion-spinner>
          <span>Cargando catálogo...</span>
        </div>
      </div>
    </div>

    <!-- Botón Inferior Fijo de Creación a lo Largo -->
    <div class="pg-new-btn-fixed">
      <button class="pg-new-solicitud-btn" (click)="openAddModal()">
        <ion-icon name="add-circle"></ion-icon>
        <span>Nuevo {{ entityName || 'Registro' }}</span>
      </button>
    </div>

  </div>
</ion-content>